import { all } from "redux-saga/effects";
import { commonWatchers } from "../modules/common";
import { configurationWatchers } from "../modules/configuration";
import { languageWatchers } from "../modules/language";
import { surgeryWatchers } from "../modules/surgery";

const allSagas = [commonWatchers(), configurationWatchers(), languageWatchers(), surgeryWatchers()];

export const createSagas = () =>
  function* combineSagas() {
    yield all([...allSagas]);
  };
